"use client"

import { useEffect, useState } from 'react'

/** SSR-safe media query hook — starts `false` and resolves after mount to avoid hydration mismatches. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia(query)
    setMatches(mq.matches)
    const handleChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    mq.addEventListener('change', handleChange)
    return () => mq.removeEventListener('change', handleChange)
  }, [query])

  return matches
}

export const MOBILE_QUERY = '(max-width: 768px)'
export const useIsMobile = () => useMediaQuery(MOBILE_QUERY)
